import { gql } from '__generated__';

export const TicketFieldsFragment = gql(`
  fragment TicketFields on Ticket {
    id
    title
    distance
    distance_unit
    description
    instructions
    image {
      id
      url
    }
    time_slots {
      id
      start_date
      start_time
      title
      capacity
      deletable
      sold_count
      invitation_reservations_count
      active
      locale
      translations {
        ...TranslationFields
      }
    }
    standard_promotion {
      id
      title
      capacity
      amount
      vat_percentage
      start_date
      end_date
      standard
      active
      sold_count
      deletable
    }
    promotions {
      id
      title
      capacity
      amount
      vat_percentage
      start_date
      end_date
      standard
      active
      invitation_reservations_count
      sold_count
      deletable
      locale
      translations {
        ...TranslationFields
      }
    }
    hide_on_invoice
    invoice_text
    allow_companies
    vat_percentage
    business
    preregistration
    units
    capacity
    min_per_order
    max_per_order
    allow_individuals
    allow_create_team
    allow_join_team
    allow_down_payments
    restrictions {
      id
      gender
      min_age
      max_age
    }
    assignment_type
    invitation_reservations_count
    invitations {
      id
      prefix
      max_uses
      usable
      has_unique_codes
    }
    ledger_account
    sold_count
    active
    deletable
    is_sold_out
    locale
    translations {
      ...TranslationFields
    }
  }
`);

export default gql(`
  query GetTicket($event_id: ID!, $ticket_id: ID!) {
    ticket(id: $ticket_id) {
      ...TicketFields
    }
    event(id: $event_id) {
      id
      title
      logo {
        id
        url
      }
      confirmation_mail_text
      locale
      brand_color
      start_date
      age_threshold_date
      private_teams
      vat_number
    }
    distanceUnits
  }
`);
